<template>
  <div class="loading">
    <img
      class="rotate_png"
      src="../assets/loading.png"
    />
    <!-- <img
      class="back_png"
      src="../assets/images/loading/291b8f3c282f1bca3a201b42d232100.png"
    /> -->
  </div>
</template>

<script>
export default {
  name: 'LOADING',
  data() {
    return {}
  },
}
</script>
<style lang="scss" scoped>
.loading {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.1);
  display: table-cell;
  vertical-align: middle;
  text-align: center;
  .rotate_png {
    width: 80px;
    height: 80px;
    position: absolute;
    top: calc(50% - 40px);
    left: calc(50% - 40px);
  }
  .back_png {
    width: 60px;
    height: 60px;
    /* margin: 7.5rem auto; */
    position: absolute;
    top: calc(50% - 30px);
    left: calc(50% - 30px);
  }
}
.rotate_png {
  -webkit-transition-property: -webkit-transform;
  -webkit-transition-duration: 1s;
  -moz-transition-property: -moz-transform;
  -moz-transition-duration: 1s;
  -webkit-animation: rotate 2s linear infinite;
  -moz-animation: rotate 2s linear infinite;
  -o-animation: rotate 2s linear infinite;
  animation: rotate 2s linear infinite;
}
@-webkit-keyframes rotate {
  from {
    -webkit-transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
  }
}
@-moz-keyframes rotate {
  from {
    -moz-transform: rotate(0deg);
  }
  to {
    -moz-transform: rotate(359deg);
  }
}
@-o-keyframes rotate {
  from {
    -o-transform: rotate(0deg);
  }
  to {
    -o-transform: rotate(359deg);
  }
}
@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(359deg);
  }
}
</style>
